import { Icon } from "@chakra-ui/react"

export const EmbedIcon = (props: any) => (
  <Icon xmlns="http://www.w3.org/2000/svg" width="29.203" height="15.655" viewBox="0 0 29.203 15.655" {...props}>
    <g transform="translate(-1 -3.156)">
      <path d="M14.983,115.041l5.448-5.448a1.394,1.394,0,1,0-1.971-1.971l-6.415,6.415a1.442,1.442,0,0,0,0,2.01l6.415,6.414a1.394,1.394,0,0,0,1.971-1.971Z" transform="translate(-10.639 -104.057)" fill="currentColor"/>
      <path d="M327.592,108.37l-6.415-6.415a1.394,1.394,0,0,0-1.971,1.971l5.448,5.448-5.448,5.448a1.394,1.394,0,1,0,1.971,1.971l6.415-6.415a1.442,1.442,0,0,0,0-2.01Z" transform="translate(-297.796 -98.391)" fill="currentColor"/>
    </g>
  </Icon>
);
